// French is the editorial reference. Profile categories are UI choices only;
// account persistence and any use by the agents belong to the backend handoff.
const profile = {
  fr: {
    userProfileTitle: 'Profil utilisateur',
    userProfilePlaceholder: 'Sélectionnez votre profil',
    userProfileNotSaved: 'Choix provisoire, non enregistré dans votre compte.',
    userProfile_farmer: 'Agriculteur',
    userProfile_cooperative: 'Coopérative',
    userProfile_financial_institution: 'Institution financière',
    userProfile_field_advisor: 'Conseiller de terrain',
    userProfile_agribusiness: 'Entreprise agricole ou agroalimentaire',
    userProfile_public_development_actor: 'Acteur public ou du développement',
    userProfile_other: 'Autre',
  },
  en: {
    userProfileTitle: 'User Profile',
    userProfilePlaceholder: 'Select your profile',
    userProfileNotSaved: 'Temporary selection, not saved to your account.',
    userProfile_farmer: 'Farmer',
    userProfile_cooperative: 'Cooperative',
    userProfile_financial_institution: 'Financial Institution',
    userProfile_field_advisor: 'Field Advisor',
    userProfile_agribusiness: 'Agribusiness',
    userProfile_public_development_actor: 'Public or Development Actor',
    userProfile_other: 'Other',
  },
  es: {
    userProfileTitle: 'Perfil de usuario',
    userProfilePlaceholder: 'Selecciona tu perfil',
    userProfileNotSaved: 'Selección provisional, no guardada en tu cuenta.',
    userProfile_farmer: 'Agricultor',
    userProfile_cooperative: 'Cooperativa',
    userProfile_financial_institution: 'Institución financiera',
    userProfile_field_advisor: 'Asesor de campo',
    userProfile_agribusiness: 'Empresa agrícola o agroalimentaria',
    userProfile_public_development_actor: 'Actor público o de desarrollo',
    userProfile_other: 'Otro',
  },
  pt: {
    userProfileTitle: 'Perfil de utilizador',
    userProfilePlaceholder: 'Selecione o seu perfil',
    userProfileNotSaved: 'Seleção provisória, não guardada na sua conta.',
    userProfile_farmer: 'Agricultor',
    userProfile_cooperative: 'Cooperativa',
    userProfile_financial_institution: 'Instituição financeira',
    userProfile_field_advisor: 'Técnico de campo',
    userProfile_agribusiness: 'Empresa agrícola ou agroalimentar',
    userProfile_public_development_actor: 'Ator público ou de desenvolvimento',
    userProfile_other: 'Outro',
  },
  vi: {
    userProfileTitle: 'Hồ sơ người dùng',
    userProfilePlaceholder: 'Chọn loại hồ sơ của bạn',
    userProfileNotSaved: 'Lựa chọn tạm thời, chưa được lưu vào tài khoản.',
    userProfile_farmer: 'Nông dân',
    userProfile_cooperative: 'Hợp tác xã',
    userProfile_financial_institution: 'Tổ chức tài chính',
    userProfile_field_advisor: 'Cán bộ tư vấn thực địa',
    userProfile_agribusiness: 'Doanh nghiệp nông nghiệp hoặc thực phẩm',
    userProfile_public_development_actor: 'Cơ quan công hoặc tổ chức phát triển',
    userProfile_other: 'Khác',
  },
  hi: {
    userProfileTitle: 'उपयोगकर्ता प्रोफ़ाइल',
    userProfilePlaceholder: 'अपनी प्रोफ़ाइल चुनें',
    userProfileNotSaved: 'अस्थायी चयन, आपके खाते में सहेजा नहीं गया है।',
    userProfile_farmer: 'किसान',
    userProfile_cooperative: 'सहकारी संस्था',
    userProfile_financial_institution: 'वित्तीय संस्था',
    userProfile_field_advisor: 'क्षेत्रीय सलाहकार',
    userProfile_agribusiness: 'कृषि या खाद्य व्यवसाय',
    userProfile_public_development_actor: 'सार्वजनिक या विकास क्षेत्र की संस्था',
    userProfile_other: 'अन्य',
  },
  ar: {
    userProfileTitle: 'ملف المستخدم',
    userProfilePlaceholder: 'اختر نوع ملفك',
    userProfileNotSaved: 'اختيار مؤقت، لم يُحفظ في حسابك.',
    userProfile_farmer: 'مزارع',
    userProfile_cooperative: 'تعاونية',
    userProfile_financial_institution: 'مؤسسة مالية',
    userProfile_field_advisor: 'مستشار ميداني',
    userProfile_agribusiness: 'شركة زراعية أو غذائية',
    userProfile_public_development_actor: 'جهة عامة أو تنموية',
    userProfile_other: 'أخرى',
  },
  ur: {
    userProfileTitle: 'صارف کی پروفائل',
    userProfilePlaceholder: 'اپنی پروفائل کی قسم منتخب کریں',
    userProfileNotSaved: 'عارضی انتخاب، آپ کے اکاؤنٹ میں محفوظ نہیں کیا گیا۔',
    userProfile_farmer: 'کسان',
    userProfile_cooperative: 'تعاونی ادارہ',
    userProfile_financial_institution: 'مالیاتی ادارہ',
    userProfile_field_advisor: 'فیلڈ مشیر',
    userProfile_agribusiness: 'زرعی یا غذائی کاروبار',
    userProfile_public_development_actor: 'سرکاری یا ترقیاتی ادارہ',
    userProfile_other: 'دیگر',
  },
};

export default profile;
